import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Map, InfoWindow, Marker, GoogleApiWrapper, OverlayView } from 'google-maps-react';
import PinIcon from "../../common/images-new/pin-icon.svg"
// position: 'relative',
// width: '288px',
const containerStyle = {
    // position: window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase" || window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase2" ? 'none' : 'relative',
    // height: window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase" || window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase2" ? '160px' : '302px',
    // width: window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase" || window.location.pathname.split('/').filter(Boolean)[0] == "myshowcase2" ? 'auto' : '288px'
    position: 'none',
    height: '160px',
    width: 'auto'
}

function MapGoogle({ style }) {
    const [activeMarker, setActiveMarker] = useState({});
    const [selectedPlace, setSelectedPlace] = useState({});
    const [showingInfoWindow, setShowingInfoWindow] = useState(false);
    const centerPoint = { lat: 1.372082067940902, lng: 103.87135304140541 }

    const locations = useSelector(state => state.showcase.locations)
    const [google, setGoogle] = useState(null);

    const onMarkerClick = (props, marker, e) => {
        setSelectedPlace(props)
        setActiveMarker(marker)
        setShowingInfoWindow(true)
    }

    const onInfoWindowClose = () => {
        setActiveMarker(null)
        setShowingInfoWindow(false)
    };

    return (
        <Map
            containerStyle={containerStyle}
            google={window.google}
            zoom={10}
            initialCenter={centerPoint}
            streetViewControl={false}
        >
            {
                locations &&
                locations.map((marker, index) => (
                    <Marker
                        onClick={onMarkerClick}
                        key={index}
                        icon={{
                            url: PinIcon,
                            anchor: new window.google.maps.Point(32, 32),
                            scaledSize: new window.google.maps.Size(32, 32)
                        }}
                        currentlat={marker.lat + "_" + marker.lng}
                        position={{ lat: marker.lat, lng: marker.lng }}
                        title={marker.title}
                        postId={marker.id}
                    />
                )
                )}

            {/* <InfoWindow
                marker={activeMarker}
                onClose={onInfoWindowClose}
                visible={showingInfoWindow}
            >
               
            </InfoWindow> */}
            {/* {true && ( */}
            {/* //   <CustomOverlay lat={1.372082067940902} lng={103.87135304140541}>
        //     <div>Custom HTML</div>
        //   </CustomOverlay> */}
            {/* )} */}

        </Map>

    )

}

export default GoogleApiWrapper({
    apiKey: ('AIzaSyDXgsxWEgtVWgZdU5W4htOoQgUOOVeYK1k')
})(MapGoogle)

// GoogleApiWrapper({
//     apiKey: ('AIzaSyDXgsxWEgtVWgZdU5W4htOoQgUOOVeYK1k')
// })(MapGoogle)
